import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Linkedin, Twitter } from 'lucide-react';
import { companyInfo } from '../../data/companyInfo';
import { NAVIGATION_ITEMS } from '../../utils/constants';
import { LogoLockup } from '../ui/Logo';

const Footer = () => {
  const { address, contact, socialMedia, name, tagline } = companyInfo;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-400">
      <div className="container-tight py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" aria-label={`${name} — home`}>
              <LogoLockup tone="light" />
            </Link>
            <p className="mt-4 max-w-sm leading-relaxed">
              {tagline}. Your strategic partner for enterprise-grade computing and networking
              solutions.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href={socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NEAT Systems on LinkedIn"
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/5 transition-colors hover:bg-white/10 hover:text-white"
              >
                <Linkedin className="h-4 w-4" aria-hidden="true" />
              </a>
              <a
                href={socialMedia.twitter}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NEAT Systems on Twitter"
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/5 transition-colors hover:bg-white/10 hover:text-white"
              >
                <Twitter className="h-4 w-4" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <nav aria-label="Footer">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Company</h4>
            <ul className="mt-4 space-y-2.5">
              {NAVIGATION_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="transition-colors hover:text-white">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex gap-2.5">
                <MapPin className="h-5 w-5 shrink-0 text-brand-400" aria-hidden="true" />
                <span>
                  {address.city}, {address.state}
                </span>
              </li>
              <li>
                <a
                  href={`tel:${contact.phone1.replace(/[^+\d]/g, '')}`}
                  className="flex gap-2.5 transition-colors hover:text-white"
                >
                  <Phone className="h-5 w-5 shrink-0 text-brand-400" aria-hidden="true" />
                  {contact.phone1}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="flex gap-2.5 transition-colors hover:text-white"
                >
                  <Mail className="h-5 w-5 shrink-0 text-brand-400" aria-hidden="true" />
                  {contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-sm">
            &copy; {year} {name}. All rights reserved.
          </p>
          <p className="text-sm">{tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
